import { render, staticRenderFns } from "./DesPopper.vue?vue&type=template&id=ec8d09ec&scoped=true&"
import script from "./DesPopper.vue?vue&type=script&lang=js&"
export * from "./DesPopper.vue?vue&type=script&lang=js&"
import style0 from "./DesPopper.vue?vue&type=style&index=0&id=ec8d09ec&lang=scss&scoped=true&"
import style1 from "./DesPopper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8d09ec",
  null
  
)

export default component.exports